/**
 * User profile operations — the current user's display identity.
 */

import type { ArbiClient, components } from '@arbidocs/client'
import { requireData } from '../errors.js'

export type UpdateProfileRequest = components['schemas']['UpdateProfileRequest']

/**
 * Update the signed-in user's profile. Fields are optional — pass only what
 * changes (e.g. `given_name`, `family_name`, `picture`).
 */
export async function updateProfile(arbi: ArbiClient, body: UpdateProfileRequest) {
  return requireData(
    await arbi.fetch.PATCH('/v1/user/profile', { body }),
    'Failed to update profile'
  )
}
